// src/SetPassmarkForm.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, InviteModal, SuccessModal } from "../../components/modal";

const SetPassmarkForm = () => {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [passmarks, setPassmarks] = useState({
    excellent: "",
    veryGood: "",
    good: "",
    average: "",
    poor: "",
    fail: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPassmarks({
      ...passmarks,
      [name]: value,
    });
  };

  const handleUpload = (ev) => {
    ev.preventDefault();
    setIsSuccessModalOpen(true);
  };

  //   const handleInviteSubmit = (ev) => {
  //     ev.preventDefault();
  //     setIsInviteModalOpen(false);
  //     setIsSuccessModalOpen(true);
  //   };

  const closeSuccessModal = () => setIsSuccessModalOpen(false);

  const navigate = useNavigate();

  return (
    <div className="p-3 bg-white rounded-lg shadow-lg m-4 h-auto font-satoshi">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-[16px] font-bold mb-4 text-[#400167]">
          Set Passmark
        </h1>
        {[
          "Excellent (A)",
          "Very Good (B)",
          "Good (B')",
          "Average (C)",
          "Poor (D)",
          "Fail (F)",
        ].map((label, index) => (
          <div key={index} className="mb-4">
            <label className="block text-[#000000] text-[16] font-semibold mb-4">
              {label}
            </label>
            <input
              type="text"
              name={label.toLowerCase().split(" ")[0]}
              placeholder="75% and above"
              value={passmarks[label.toLowerCase().split(" ")[0]]}
              onChange={handleChange}
              className="appearance-none border border-[#000000] rounded w-[683.89px] py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>
        ))}
        <div className="flex items-center gap-4 mt-20">
          <button
            onClick={handleUpload}
            className="bg-[#5002D0] w-[480px] text-white font-bold py-4 px-4 rounded-full"
          >
            Upload
          </button>

          <SuccessModal
            isOpen={isSuccessModalOpen}
            onClose={closeSuccessModal}
          />
          <button
            className="text-[#000000] hover:underline font-bold py-2 px-4 underline"
            onClick={() => navigate("/lessons/add-topic-form")}
          >
            Add New Topic
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetPassmarkForm;
